"use client";

import DropdownSearch from "./DropdownSearch";
import { Sparkles } from "./Sparkles";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import assetContext from "../../context/AssetsContext/AssetContext";
 
const AnimatedText = ({ text }) => {
  return (
    <span className="inline-block animate-slideInGlow" key={text}>
      {text}
    </span>
  );
};

export default function Landingpage1() {
  const navigate = useNavigate();
  const [textSet, setTextSet] = useState({
    first: "Stop Stressing",
    second: "Start Selling",
  });

  const handleDataReceived = async (data) => {
    const filtersx = data.filters;
    const queryParams = new URLSearchParams({
      page: 1,
      property_type: filtersx !== null ? filtersx.property_type : [],
      property_status: filtersx !== null ? filtersx.property_status : [],
      city: filtersx !== null ? filtersx.city : [],
      property_builder: filtersx !== null ? filtersx.property_builder : [],
      bedroom: filtersx !== null ? filtersx.bedroom : [],
      property_price: filtersx !== null ? filtersx.property_price : 20,
      bath_rooms: filtersx !== null ? filtersx.bath_rooms : [],
      balconies: filtersx !== null ? filtersx.balconies : [],
      door_facing: filtersx !== null ? filtersx.door_facing : [],
      furnishing_status: filtersx !== null ? filtersx.furnishing_status : [],
      parking: filtersx !== null ? filtersx.parking : [],
      property_name: data.text,
    }).toString();

    navigate(`/properties?${queryParams}`);
  };

  const context = useContext(assetContext);
  const { getAvailableFilters, availableFilters } = context;

  useEffect(() => {
    getAvailableFilters();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTextSet((prev) =>
        prev.first === "Stop Stressing"
          ? { first: "Scroll No More", second: "Adore your floor" }
          : { first: "Stop Stressing", second: "Start Selling" }
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-screen overflow-hidden bg-black flex flex-col justify-center items-center">
      {/* Headings */}
      <div className="flex flex-col items-center justify-center mt-10 space-y-6">
        <div className="flex items-center justify-center space-x-4">
          <h1
            // className="text-5xl w-full md:text-7xl font-bold bg-gradient-to-b from-white to-blue-100 bg-clip-text text-transparent tracking-tighter"
            style={{ fontFamily: "Playfair Display, sans-serif" }}
            className="text-white text-5xl md:text-7xl"
          >
            <AnimatedText text={textSet.first} />
          </h1>
        </div>

        <div className="flex items-center justify-center gap-2">
          <h1
            style={{ fontFamily: "Playfair Display, sans-serif" }}
            className="text-white text-5xl md:text-7xl"
          >
            <AnimatedText text={textSet.second} />
          </h1>
        </div>
      </div>

      <div className="flex justify-center mt-10 px-4">
        <p
          style={{ fontFamily: "Poppins, sans-serif" }}
          className="text-white text-center w-full md:w-[40vw]"
        >
          Resale Properties makes your property ready for quick resale—handling
          everything from marketing to negotiations, ensuring top-tier buyers
          and the best price in no time.
        </p>
      </div>

      <div className="relative h-96 w-full -mt-10 overflow-hidden [mask-image:radial-gradient(50%_50%,white,transparent)] before:absolute before:inset-0 before:bg-[radial-gradient(circle_at_bottom_center,#8350e8,transparent_70%)] before:opacity-40 after:absolute after:-left-1/2 after:top-1/2 after:aspect-[1/0.7] after:w-[200%] after:rounded-[100%] after:border-t after:border-[#7876c566] after:bg-zinc-900">
        <Sparkles
          density={1200}
          className="absolute inset-x-0 bottom-0 h-full w-full [mask-image:radial-gradient(50%_50%,white,transparent_85%)]"
        />
      </div>
      <Sparkles
          density={500}
          className="absolute inset-x-0 bottom-0 h-full w-full [mask-image:radial-gradient(50%_50%,white,transparent_85%)]"
        />
      <div className="flex justify-center items-center text-center px-4 md:px-8 lg:px-16 py-10">
        <DropdownSearch
          onDataReceived={handleDataReceived}
          locationaOptions={
            availableFilters !== null &&
            availableFilters.property_location.length > 0
              ? availableFilters.property_location
              : []
          }
          configOptions={
            availableFilters !== null &&
            availableFilters.property_bhk.length > 0
              ? availableFilters.property_bhk
              : []
          }
          style={{ width: "100%", backgroundColor: "black" }}
        />
      </div>
    </div>
  );
}
